import LogoSvg from '@/assets/logo_color.svg';

const Logo = () => (
    <img src={LogoSvg} alt="MindAssist Logo" width={180} />
);

export default Logo;
